<div class="well--sig">
    <div [class]="classes"><img [src]="signature" /></div>
    <!--<div [class]="classes" [style.background-image]="'url(data:image/png;base64,' + driverLicense.photo + ')'"><img [src]="signature" /></div>-->
    <!--<div [class]="classes" [style.background-image]="url(signature)"></div>-->
</div>